import React from "react";

const NewUserIcon = () => {
  return (
    <svg
      width="35"
      height="34"
      viewBox="0 0 35 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9321 3.14632C9.23433 3.14632 6.22815 6.06536 6.22815 9.65593C6.22815 13.178 9.06497 16.0285 12.7627 16.1518C12.8756 16.1381 12.9885 16.1381 13.0732 16.1518C13.1014 16.1518 13.1155 16.1518 13.1438 16.1518C13.1579 16.1518 13.1579 16.1518 13.172 16.1518C16.7851 16.0285 19.6219 13.178 19.636 9.65593C19.636 6.06536 16.6298 3.14632 12.9321 3.14632Z"
        fill="#40E5A0"
      />
      <path
        d="M20.1017 19.7986C16.164 17.2496 9.74236 17.2496 5.77646 19.7986C3.98404 20.9635 2.99609 22.5395 2.99609 24.2251C2.99609 25.9108 3.98404 27.4731 5.76234 28.6242C7.73824 29.9125 10.3351 30.5566 12.932 30.5566C15.5289 30.5566 18.1258 29.9125 20.1017 28.6242C21.88 27.4594 22.8679 25.8971 22.8679 24.1977C22.8538 22.5121 21.88 20.9498 20.1017 19.7986Z"
        fill="#40E5A0"
      />
      <path
        d="M28.4428 10.4659C28.6686 13.1245 26.7209 15.4543 24.0253 15.7695C24.0112 15.7695 24.0111 15.7695 23.997 15.7695H23.9547C23.87 15.7695 23.7853 15.7695 23.7148 15.7969C22.3458 15.8654 21.0896 15.4406 20.144 14.6594C21.5977 13.3986 22.4304 11.5074 22.2611 9.45173C22.1623 8.34167 21.7671 7.32754 21.1743 6.46416C21.7106 6.20378 22.3316 6.03933 22.9667 5.98451C25.733 5.75153 28.2029 7.75238 28.4428 10.4659Z"
        fill="#40E5A0"
      />
      <path
        d="M31.2654 23.1425C31.1525 24.4718 30.2775 25.623 28.8097 26.4041C27.3983 27.1579 25.62 27.5142 23.8558 27.4731C24.872 26.5823 25.4648 25.4722 25.5777 24.2936C25.7188 22.5943 24.8861 20.9635 23.2207 19.6615C22.2751 18.9352 21.1743 18.3596 19.9746 17.9348C23.0937 17.0577 27.0173 17.647 29.4307 19.5382C30.7291 20.5523 31.3925 21.8268 31.2654 23.1425Z"
        fill="#40E5A0"
      />
    </svg>
  );
};

export default NewUserIcon;
